<template>
  <div>
    <!-- Modal windows -->
        <ModalVideo v-if="showModal" @close="closeModal">
          <template #header>
            <h4 class="modal-title">{{ titleVideo || 'Нет данных' }}</h4>
          </template>

          <template #body>
            <iframe
              v-if="codVideo"
              :src="`https://www.youtube.com/embed/${codVideo}`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="responsive-iframe"
            ></iframe>
            <div v-else class="video-not-found">Видео не найдено</div>
          </template>
        </ModalVideo>

        <ModalVideo v-if="showModalOnline" @close="closeModalOnline">
          <template #header>
            <h4 class="modal-title">{{ liveTitleVideo || 'Нет данных' }}</h4>
          </template>

          <template #body>
            <iframe
              v-if="liveCodVideo"
              :src="`https://www.youtube.com/embed/${liveCodVideo}`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="responsive-iframe"
            ></iframe>
            <div v-else class="video-not-found">Прямой эфир не найден</div>
          </template>
        </ModalVideo>


    <!-- Header section -->
    <header class="site-header">
      <div class="container">
        <div class="header-content">
          <div class="logo-container">
            <img :src="require('@/assets/img/logo.png')" alt="Church Logo" class="logo" />
          </div>
          <div class="header-text">
            <h1 class="site-title">Блага вість</h1>
            <h3 class="site-subtitle">Церква християн віри евангельскої</h3>
          </div>
        </div>
      </div>
    </header>

    <!-- Hero video section -->
    <div class="hero-video">
      <div class="overlay">
        <div class="overlay-content">
          <h1 class="hero-title">{{ TextBible.title }}</h1>
          <div class="hero-buttons">
            <button
              v-if="!LiveVideoData"
              class="btn btn-primary"
              @click="showModal = true"
            >
              Дивитися останє служіння
            </button>
            <button
              v-if="LiveVideoData"
              class="btn btn-accent"
              @click="showModalOnline = true"
            >
              Дивитися онлайн служіння
            </button>
          </div>
        </div>
      </div>
      <video
        loop
        muted
        autoplay
        poster="../assets/video/plane.jpg"
        class="background-video"
      >
        <source :src="require('@/assets/video/plane.mp4')">
        <source :src="require('@/assets/video/plane.webm')" type="video/webm">
      </video>
    </div>

    <!-- Countdown timer -->
    <Timer v-if="!LiveVideoData" />

    <!-- Services section -->
    <section class="services-section">
      <div class="container">
        <h2 class="section-title">Сервіси</h2>
        <div class="services-grid">
          <div class="service-card">
            <i aria-hidden="true" class="fas fa-praying-hands service-icon"></i>
            <p class="service-text">Молитва</p>
          </div>
          <div class="service-card">
            <i aria-hidden="true" class="fas fa-bible service-icon"></i>
            <p class="service-text">Навчання практичному Слову Божому</p>
          </div>
          <div class="service-card">
            <i aria-hidden="true" class="fas fa-hands-helping service-icon"></i>
            <p class="service-text">Підтримка</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Bible verse banner -->
    <div class="bible-banner">
      <div class="container">
        <h2 class="bible-verse">
          Ісус відповів: „Поправді, поправді кажу Я тобі: Коли хто не родиться з води й Духа,
          той не може ввійти в Царство Боже. /Івана 3 : 5/
        </h2>
      </div>
    </div>

    <!-- Blog/Ministries section -->
    <section class="blog-section">
      <div class="container">
        <Ministries />
      </div>
    </section>

    <!-- Footer -->
    <footer class="site-footer">
      <div class="container">
        <div class="footer-content">
          <iframe
            allowfullscreen
            aria-hidden="false"
            frameborder="0"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2595.4405292888096!2d32.10316!3d49.419485!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9101cca08af2968c!2z0KbQtdGA0LrQvtCy0Ywg0JHQu9Cw0LPQsNGPINCS0LXRgdGC0Ywg0KfQtdGA0LrQsNGB0YHRiw!5e0!3m2!1suk!2sus!4v1603789520347!5m2!1suk!2sus"
            class="map-embed"
            tabindex="0"
          ></iframe>
          <div class="footer-info">
            <div class="brand">{{ new Date().getFullYear() }} — Блага вість Черкаси</div>
            <nav class="footer-nav">
              <ul class="social-menu">
                <li v-for="icon in icons" :key="icon.icon" class="social-item">
                  <a :href="icon.src" class="social-link" target="_blank" rel="noopener">
                    <i :class="icon.fontawesome" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, computed, onMounted, ref } from 'vue'
import store from '@/store'
import useSWRFetch from '@/composables/useSWRFetch'

// Lazy-load components for better performance
const Timer = defineAsyncComponent(() => import('@/components/Timer.vue'))
const ModalVideo = defineAsyncComponent(() => import('@/components/ModalVideo.vue'))
const Ministries = defineAsyncComponent(() => import('@/components/Ministries.vue'))

export default defineComponent({
  name: 'HomePage',
  components: {
    ModalVideo,
    Ministries,
    Timer
  },
  setup() {
    // Bible verse data
    const TextBible = ref({})

    // SWR for fetching YouTube data with caching
    const { data: VideoDevelopers, error } = useSWRFetch(
      'https://www.googleapis.com/youtube/v3/playlistItems?playlistId=PLlURDWJlf7fT9p77c-wQOzVIG_GLs32Pq&key=AIzaSyAHq7nCX7e6FxeXJ6JWD_iqWMb7_sHCdoU&part=snippet&maxResults=1'
    )

    // Computed properties for video data
    const LastVideoData = computed(() => {
      if (VideoDevelopers.value?.items?.length > 0) {
        return VideoDevelopers.value.items[0].snippet
      }
      return null
    })

    const LiveVideoData = computed(() => store.state.LiveVideoData)

    // Safe access for video titles and IDs
    const titleVideo = computed(() => LastVideoData.value?.title || '')
    const codVideo = computed(() => LastVideoData.value?.resourceId?.videoId || '')
    const liveTitleVideo = computed(() => LiveVideoData.value?.snippet?.title || '')
    const liveCodVideo = computed(() => LiveVideoData.value?.id?.videoId || '')

    // Modal state
    const showModal = ref(false)
    const showModalOnline = ref(false)

    // Social icons
    const icons = computed(() => store.state.icons)

    // Load video data on mount
    onMounted(async () => {
      // Load videos
      store.dispatch('getLastVideoData')
      store.dispatch('getLiveVideoData')

      // Load Bible verse
      try {
        const response = await fetch('https://blv-vue3-tp.firebaseio.com/bible.json')
        if (!response.ok) {
          throw new Error('Ошибка загрузки данных Библии')
        }
        const data = await response.json()
        const arrayVerse = Object.keys(data).map(key => ({
          ...data[key],
          id: key
        }))
        TextBible.value = arrayVerse[Math.floor(Math.random() * arrayVerse.length)]
      } catch (error) {
        console.error('Ошибка загрузки данных Библии:', error)
      }
    })

    // Modal handlers
    const closeModal = () => {
      console.log('closeModal')
      showModal.value = false
    }

    const closeModalOnline = () => {
      showModalOnline.value = false
    }

    return {
      TextBible,
      VideoDevelopers,
      error,
      icons,
      LastVideoData,
      LiveVideoData,
      showModal,
      showModalOnline,
      titleVideo,
      codVideo,
      liveTitleVideo,
      liveCodVideo,
      closeModal,
      closeModalOnline
    }
  }
})
</script>

<style>
:root {
  --primary-color: #3f51b5;
  --accent-color: #e91e63;
  --text-color: #333;
  --text-light: #777;
  --bg-light: #fcfcfc;
  --bg-dark: #38404b;
  --text-white: #fff;
  --shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Global styles */
body {
  font-family: 'Raleway', Arial, Helvetica, sans-serif;
  margin: 0;
  padding: 0;
  color: var(--text-color);
  line-height: 1.6;
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  font-weight: 600;
}

p {
  margin-top: 0;
  color: var(--text-light);
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

.section-title {
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  font-size: 2rem;
}

.section-title:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: var(--accent-color);
}

/* Header styles */
.site-header {
  background-color: #fff;
  padding: 1rem 0;
  box-shadow: var(--shadow);
}

.header-content {
  display: flex;
  align-items: center;
}

.logo-container {
  width: 80px;
  margin-right: 1rem;
}

.logo {
  width: 100%;
}

.site-title {
  font-size: 1.8rem;
  margin: 0;
  color: var(--primary-color);
}

.site-subtitle {
  font-size: 1.2rem;
  margin: 0;
  font-weight: 400;
  color: var(--text-light);
}

/* Hero video section */
.hero-video {
  position: relative;
  height: 100vh;
  max-height: 650px;
  overflow: hidden;
}

.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.overlay-content {
  text-align: center;
  max-width: 800px;
  padding: 0 2rem;
}

.hero-title {
  color: var(--text-white);
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Button styles */
.btn {
  display: inline-block;
  padding: 0.8rem 1.5rem;
  font-weight: 600;
  text-align: center;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 1rem;
}

.btn-primary {
  background-color: var(--primary-color);
  color: var(--text-white);
}

.btn-primary:hover {
  background-color: #303f9f;
}

.btn-accent {
  background-color: var(--accent-color);
  color: var(--text-white);
}

.btn-accent:hover {
  background-color: #c2185b;
}

/* Services section */
.services-section {
  padding: 5rem 0;
  background-color: #fff;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.service-card {
  padding: 2rem;
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: #fff;
  box-shadow: var(--shadow);
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.service-icon {
  color: var(--primary-color);
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.service-text {
  font-size: 1.1rem;
  margin: 0;
}

/* Bible banner */
.bible-banner {
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(../assets/img/jumbotron.jpg);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  padding: 5rem 0;
  text-align: center;
}

.bible-verse {
  color: var(--text-white);
  font-size: 1.8rem;
  max-width: 900px;
  margin: 0 auto;
  font-weight: 500;
  line-height: 1.4;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* Blog section */
.blog-section {
  padding: 5rem 0;
  background-color: var(--bg-light);
}

/* Footer styles */
.site-footer {
  background-color: var(--bg-dark);
  padding: 3rem 0 2rem;
  color: var(--text-white);
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.map-embed {
  width: 100%;
  height: 300px;
  border-radius: 8px;
  box-shadow: var(--shadow);
}

.footer-info {
  text-align: center;
}

.brand {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #bcc9dd;
}

.social-menu {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 1.5rem 0 0;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: #bcc9dd;
  transition: all 0.3s ease;
}

.social-link:hover {
  background-color: var(--primary-color);
  color: var(--text-white);
  transform: translateY(-3px);
}

/* Modal styles */
.modal-title {
  margin: 0;
  font-size: 1.4rem;
  color: var(--text-color);
}

.responsive-iframe {
  width: 100%;
  height: 56.25vw;
  max-height: 600px;
  border-radius: 4px;
}

.video-not-found {
  padding: 2rem;
  text-align: center;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 991px) {
  .hero-title {
    font-size: 2.2rem;
  }

  .bible-verse {
    font-size: 1.6rem;
  }
}

@media (max-width: 767px) {
  .hero-video {
    max-height: 500px;
  }

  .hero-title {
    font-size: 1.8rem;
  }

  .bible-verse {
    font-size: 1.4rem;
  }

  .service-card {
    padding: 1.5rem;
  }
}

@media (max-width: 575px) {
  .site-header {
    padding: 0.8rem 0;
  }

  .logo-container {
    width: 60px;
  }

  .site-title {
    font-size: 1.5rem;
  }

  .site-subtitle {
    font-size: 1rem;
  }

  .hero-video {
    max-height: 400px;
  }

  .hero-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .btn {
    padding: 0.6rem 1.2rem;
  }

  .services-section,
  .blog-section {
    padding: 3rem 0;
  }

  .bible-banner {
    padding: 3rem 0;
  }

  .bible-verse {
    font-size: 1.2rem;
  }

  .responsive-iframe {
    height: 65vw;
  }
}
</style>
